import { render, staticRenderFns } from "./form.vue?vue&type=template&id=328d504f&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=328d504f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d504f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328d504f')) {
      api.createRecord('328d504f', component.options)
    } else {
      api.reload('328d504f', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=328d504f&scoped=true&", function () {
      api.rerender('328d504f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/merge_assessment_account_management/merge_assessment/form/form.vue"
export default component.exports